/*import { BehaviorSubject, observable } from 'rxjs/Rx';*/
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { URL_SERVICIOS_CONSOTA, URL_SIGEC } from '../config/config';
import { Solicitudplan } from '../models/solicitudplan.model';

import Swal from 'sweetalert2';

import * as Sentry from '@sentry/browser';

interface IReserva {
  email: String;
}

@Injectable({
  providedIn: 'root'
})

export class SigecService {
  constructor(public http: HttpClient) { }

  async executeFetch(url: string, origen: string) {
    try {
      const response = await fetch(url);
      switch (response.status) {
        case 404:
          const error404 = new Error('Error 404 ejecutando url: ' + url) + ' desde ' + origen;
          Sentry.captureException(error404);
          Swal.fire(
            'Error consultando datos',
            'Se ha notificado al administrador del sistema. Por favor intente de nuevo mas tarde',
            'error'
          );
          return undefined;
        case 200:
          const data = await response.json();

          return data;
        default:
            const error = new Error('Error ' + response.status + ' ejecutando url: ' + url) + ' desde ' + origen;
            Sentry.captureException(error);
            Swal.fire(
              'Error consultando datos',
              'Se ha notificado al administrador del sistema. Por favor intente de nuevo mas tarde',
              'error'
            );
            return undefined;
      }
    } catch (error) {
      Sentry.captureException(error);
      Swal.fire(
        'Error consultando datos',
        'Se ha notificado al administrador del sistema. Por favor intente de nuevo mas tarde',
        'error'
      );
    }
  }

  async consultarProcesoAutenticacion(cunumid: string,
    pvcod: string,
    clave: string) {
    const url = URL_SIGEC + 'consultarProcesoAutenticacion/' + cunumid + '/' + pvcod + '/' + clave;

    const data = await this.executeFetch(url, 'consultarProcesoAutenticacion');

    return data;
  }

  async consultarProcesoVentaCodigo(pvcod: string) {
    const url = URL_SIGEC + 'consultarProcesoVentaCodigo/' + pvcod;

    const data = await this.executeFetch(url, 'consultarProcesoVentaCodigo');

    return data;
  }

  async validatebankpayment(transaccionconvenioid: string,
    hash: string) {

      const url = URL_SIGEC + 'validatebankpayment';
      let datos;

      datos = JSON.stringify({
        transaccionconvenioid,
        hash
      });
      const response = await fetch(url,
        {
            headers: {
              'Accept': 'application/json',
              // 'Content-Type': 'application/x-www-form-urlencoded'
              'Content-Type': 'application/json'
            },
            method: 'POST',
            body: datos
        });
      const data = await response.json();
      return data;

  /*
    const url = URL_SIGEC + 'validatebankpayment/'
                + transaccionconvenioid + '/' +
                hash;
    debugger;
    const response = await fetch(url);
    const data = await response.json();

    console.log('Datos:, ', data);
    return data;
    */
  }
}

